import React, { useState, useEffect } from "react";
import ElementModal from "../../Pages/Kdf/EditKdf/elementModal/ElementModal";
import Button from "../../Elements/Button";
import FormFieldsSection, { showsElementPosition } from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/FormFieldsSection";
import ElementSizeBlock from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/ElementSizeBlock";
import ElementPosition from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/ElementPosition";
import { languagesSummary } from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/sectionSummaries";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faFont, faGlobe, faImage, faPlay } from "@fortawesome/free-solid-svg-icons";
import DisplayLanguagesSection from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/DisplayLanguagesSection";
import SectionCard from "../../Pages/Kdf/EditKdf/elementModal/SectionCard";
import useEditorHook from "../../Pages/Kdf/EditKdf/editorHook/useEditorHook";
import CustomForm from "../../CommonComponents/CustomForm/CustomForm";
import InternalExtendBeyondModal from "./InternalExtendBeyondModal";
import { getComparableTool } from "../../../utils/helper";
import * as _ from "lodash";
const AddElementModal = ({
    openAddElementModal,
    closeModal,
    docData,
    docFiles,
    totalPages,
    zoom,
    applyDesiredAction,
}) => {
    // Pass openAddElementModal to useEditorHook
    const {
        tool,
        toolType,
        editElement,
        ToolSection,
        handleCloseModal,
        handleSubmitElement,
        handleChange,
        setTool,
        initialTool,
        initialEditElement,
        scrollActive,
        isChanged,
        setIsChanged,
        errorState,
        handleSubmitBtnState,
        showExtendModal,
        setShowExtendModal,confirmedGeometry,
        handleImageUpload
    } = useEditorHook(closeModal, docData, totalPages, zoom, applyDesiredAction, openAddElementModal); 

    const languages = docFiles?.filter((elem) => elem?.id !== docData?.id);

    const contentSectionTitle = (() => {
        if (toolType === 'ImageToolbox' || editElement?.element_type === 4) return 'Image';
        if (toolType === 'VideoToolbox' || editElement?.element_type === 5) return 'Video';
        if (toolType === 'EmbedToolbox' || editElement?.element_type === 6) return 'Embed';
        if (toolType === 'TextToolbox' || editElement?.element_type === 2 || editElement?.element_type === 7) return 'Text Content';
        return null;
    })();

    const sizeInContent = !!contentSectionTitle && toolType !== 'Clone' && toolType !== 'LightboxesToolbox';
    const contentIcon = { Image: faImage, Video: faPlay, Embed: faGlobe, 'Text Content': faFont }[contentSectionTitle];
    const videoSource = contentSectionTitle === 'Video' ? tool?.value?.source : null;
    const isHotspot = (toolType === 'HotspotToolbox' || editElement?.element_type === 9) && toolType !== 'Clone';
    const dimensionSection = sizeInContent ? contentSectionTitle : isHotspot ? 'Appearance' : 'Layout & Position';

    const contentSectionError = (() => {
        if (toolType === 'ImageToolbox' || editElement?.element_type === 4) return errorState?.imgErr;
        if (toolType === 'VideoToolbox' || editElement?.element_type === 5) return errorState?.videoErr;
        if (toolType === 'EmbedToolbox' || editElement?.element_type === 6) return errorState?.embedErr;
        if (toolType === 'TextToolbox' || editElement?.element_type === 2 || editElement?.element_type === 7) return errorState?.textErr;
        return null;
    })();

    const headerErrors = [
        contentSectionError         && { section: contentSectionTitle,     error: contentSectionError },
        errorState?.dimensionError  && { section: dimensionSection, error: errorState.dimensionError },
        errorState?.pageErr         && { section: 'Click Action',          error: errorState.pageErr },
        errorState?.hrefErr         && { section: 'Click Action',          error: errorState.hrefErr },
        errorState?.ljErr           && { section: 'Click Action',          error: errorState.ljErr },
        errorState?.kdfErr          && { section: 'Click Action',          error: errorState.kdfErr },
        errorState?.tagErr          && { section: 'Metadata & Tracking',   error: errorState.tagErr },
    ].filter(Boolean);

    const [isInitialRenderAfterOpen, setIsInitialRenderAfterOpen] = useState(true);
    //  const [initialTools, setInitialTools] = useState(tool);
    useEffect(() => {
        console.log("AddElementModal: openAddElementModal changed to:", openAddElementModal);
        if (openAddElementModal) {
            setIsInitialRenderAfterOpen(true);
        } else {
            setIsInitialRenderAfterOpen(true); // Reset for next open
        }
    }, [openAddElementModal]);

    useEffect(() => {
        if (isInitialRenderAfterOpen && openAddElementModal) {
            console.log("AddElementModal: Setting isInitialRenderAfterOpen to false with setTimeout(0)");
            const timer = setTimeout(() => {
                setIsInitialRenderAfterOpen(false);
            }, 0);
            return () => clearTimeout(timer);
        }
    }, [isInitialRenderAfterOpen, openAddElementModal, tool, editElement]); 

    useEffect(()=>{console.log(tool.tags)},[tool.flip , tool.tags])
    useEffect(() => {
    const hasChanged =
        !_.isEqual(getComparableTool(tool), getComparableTool(initialTool)) ||
        !_.isEqual(editElement, initialEditElement);
    setIsChanged(hasChanged);
}, [tool, editElement, initialTool, initialEditElement]);


    const isDisabled = () => {
        if (!openAddElementModal) {
            return true;
        }

        console.log("isDisabled check:", {
            isInitialRenderAfterOpen: isInitialRenderAfterOpen,
            isChanged: isChanged,
            toolType: toolType,
            pageLinkVsPage: (+tool?.value?.page_link === +tool?.page)
        });


        if (toolType === 'Clone') {
            return (
                isInitialRenderAfterOpen ||
                (!isChanged && +tool?.value?.page_link === +tool?.page)
            );
        } else {
            return (
                isInitialRenderAfterOpen ||
                (!isChanged && !isInitialRenderAfterOpen) ||
                (+tool?.value?.page_link === +tool?.page)
            );
        }
    };

    // Footer with Save buttons
    const modalFooter = (
        <div>
            <div className="d-flex align-items-center justify-content-between m-2">
                <span className={`elem-modal-dirty${isChanged && !isInitialRenderAfterOpen ? '' : ' clean'}`}>
                    {isChanged && !isInitialRenderAfterOpen ? <><FontAwesomeIcon icon={faCircle} className="elem-modal-dirty-dot" /> Unsaved changes</> : ''}
                </span>
                <Button
                    classList={'success'}
                    addonClass={'elem-save'}
                    onClick={(e) =>
                        handleSubmitElement(
                            e,
                            tool?.element_type_name === 'Image' ? editElement?.id : null,
                            toolType === 'LightboxesToolbox' ? 'image' : ''
                        )
                    }
                    text={toolType === 'Clone' ? 'Clone' : 'Save'}
                    type="submit"
                    disabled={isDisabled()}
                />
            </div>
            {headerErrors.length > 0 && (
                <div className="elem-modal-footer-errors">
                    <i className="fa-solid fa-triangle-exclamation" />
                    <ul>
                        {headerErrors.map((e, i) => (
                            <li key={i}>
                                <strong>{e.section}:</strong> {e.error}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="republish-banner">
                After saving, republish this KDF for recipients to experience your changes.
            </div>
        </div>
    );

    return (
        <ElementModal
            openModal={openAddElementModal}
            heading={ToolSection()?.header}
            handleCloseModal={handleCloseModal}
            footer={modalFooter}
            headerErrors={headerErrors}
        >
            {showExtendModal &&         <InternalExtendBeyondModal
                                        openModal={showExtendModal}
                                        closeModal={setShowExtendModal}
                                            tool={tool}
                                            setTool={setTool}
                                            revertTo={confirmedGeometry.current}
                                            // setShowToast={} // To display messages (from useEditorHook or parent of AddElementModal)
                                        />}

             <div className="image-popup">
                <CustomForm className="popup-content">
                    {toolType !== 'Clone' && contentSectionTitle ? (
                        <SectionCard title={contentSectionTitle} variant="content" defaultOpen={true} errors={sizeInContent ? [contentSectionError, errorState?.dimensionError] : [contentSectionError]}>
                            {ToolSection()?.component}
                            {videoSource && (
                                <span className="pv-provider"><FontAwesomeIcon icon={faCheck} /> {({ youtube: 'YouTube', vimeo: 'Vimeo', wistia: 'Wistia', loom: 'Loom' })[videoSource] ?? videoSource}</span>
                            )}
                            {sizeInContent && (
                                <ElementSizeBlock
                                    tool={tool}
                                    handleChange={handleChange}
                                    errorState={errorState}
                                    icon={contentIcon}
                                    imageUrl={contentSectionTitle === 'Image' ? (tool?.value?.gif_link || editElement?.file_url || null) : undefined}
                                    tone={['Video', 'Embed'].includes(contentSectionTitle) ? 'dark' : 'light'}
                                    fill={contentSectionTitle === 'Image' ? tool?.value?.bg_color || null : undefined}
                                    onPickFile={contentSectionTitle === 'Image' ? (e) => handleImageUpload(e, 'upload') : undefined}
                                    presetSet={{ Image: 'image', Video: 'video', Embed: 'embed', 'Text Content': 'text' }[contentSectionTitle]}
                                    naturalSize={tool?.original_width && tool?.original_height ? { width: tool.original_width, height: tool.original_height } : editElement?.file_details?.dimensions}
                                >
                                    {showsElementPosition(toolType, editElement) && (
                                        <ElementPosition
                                            handleChange={handleChange}
                                            tool={tool}
                                            toolType={toolType}
                                            editElement={editElement}
                                            variant="checkbox"
                                        />
                                    )}
                                </ElementSizeBlock>
                            )}
                        </SectionCard>
                    ) : (
                        toolType !== 'Clone' && ToolSection()?.component
                    )}
                    {toolType !== 'LightboxesToolbox' && (
                        <>
                            <FormFieldsSection
                                handleChange={handleChange}
                                scrollActive = {scrollActive}
                                tool={tool}
                                toolType={toolType}
                                docData={docData}
                                editElement={editElement}
                                setTool={setTool}
                                totalPages={totalPages}
                                errorState={errorState}
                                zoom={zoom}
                                handleSubmitBtnState={handleSubmitBtnState}
                                sizeInContent={sizeInContent}
                            />
                            {languages?.length > 0 && (
                                <SectionCard title="Display languages" variant="metadata" summary={languagesSummary(tool, languages)}>
                                    <DisplayLanguagesSection
                                        languages={languages}
                                        toolType={toolType}
                                        tool={tool}
                                        setTool={setTool}
                                        handleSubmitBtnState={handleSubmitBtnState}
                                    />
                                </SectionCard>
                            )}
                            {toolType === 'Clone' && (
                                <em className="px-0">
                                    {/* Note: Before duplicating the element please change at least position (width, height, top, left) and/or page to be shown, otherwise the element will be placed above the original one. */}
                                </em>
                            )}
                        </>
                    )}
                </CustomForm>
            </div>
        </ElementModal>
    );
};

export default AddElementModal;
